$(document).ready(function () {
  
    
   //Use this inside your document ready jQuery 
   $(window).on('popstate', function() {
       location.reload(true);
   });
   
  
  $(function () {
    $(".buttonDecimal").click(function () {
      var $buttonDecimal = $(this);
      var oldValue = $buttonDecimal
        .parent()
        .find("[name='margin_quantity']")
        .val();

      if ($buttonDecimal.text() == "+") {
        var newVal = parseFloat(oldValue) + 0.1;
      } else {
        if (oldValue >= 0.1) {
          var newVal = parseFloat(oldValue) - 0.1;
        } else {
          var newVal = 0.1;
        }
      }

      $buttonDecimal
        .parent()
        .find("[name='margin_quantity']")
        .val(Math.round(newVal * 100) / 100);
    });
  });

  function add_margin(value, text) {
    var ele = $(".product_price").find(".h1");
    var variant = $(".product-variants-product-template").val();
    var price = $(
      ".product-variants-product-template option[value='" + variant + "']"
    ).attr("data-price");

    price = parseFloat(price) / 100;
    price = price * value;
    price = price.toFixed(2);

    price = Shopify.formatMoney(price * 100, Shopify.money_format);
    original = price;

    price = price.toString().split(".");

    ele.html(
      '<span aria-hidden="true">' +
        price[0] +
        "<sup>" +
        price[1] +
        '</sup></span> <span class="visually-hidden">' +
        original +
        "</span>"
    );
    localStorage.setItem("margin", value);
    localStorage.setItem("marginstatus", text);
  }

  $(document).on("click",".apply_margin", function () {
    var text = $(this).val();
    
    $(".marginset").text(text);
    var value = $(this)
      .parents(".marginsetform")
      .find('[name="margin_quantity"]')
      .val();

    localStorage.setItem("margin", value);
    
    if (value < 0.1) {
      $('[name="margin_quantity"]').val(0.1);
      value = 1;
    }

    $(".new-margin .grid-item").each(function () {
      var coll_mar = $(this).find(".product-item--price").attr("data-price");
      var price_compair_element;
      coll_mar = parseFloat(coll_mar) / 100;
      coll_mar = coll_mar * value;
      coll_mar = coll_mar.toFixed(2);
      var save_main_price = coll_mar;
      
      coll_mar = Shopify.formatMoney(coll_mar * 100, Shopify.money_format);
      coll_original = coll_mar;

      coll_price_split = coll_mar.toString().split(".");
      price_compair_element =
        `<span class="visually-hidden">` +
        coll_original +
        `</span>
          <small aria-hidden="true" class="main_price">` +
        coll_price_split[0] +
        `<sup>` +
        coll_price_split[1] +
        `</sup></small>
          <span class="visually-hidden">` +
        coll_original +
        `</span>`;

      var coll_compair = $(this)
        .find(".product-item--price")
        .attr("data-compair-price");
      if (coll_compair != 0) {
        coll_compair_up = parseFloat(coll_compair) / 100;
        coll_compair_up = coll_compair_up * value;
        coll_compair_up = coll_compair_up.toFixed(2);

        var save_price = coll_compair_up - save_main_price;
        save_price.toFixed(2);
        save_price = Shopify.formatMoney(
          save_price * 100,
          Shopify.money_format
        );
        $(this)
          .find(".product-item--price .sale-tag")
          .text("Save " + save_price);

        coll_compair_up = Shopify.formatMoney(
          coll_compair_up * 100,
          Shopify.money_format
        );
        coll_original_compair_up = coll_compair_up;

        coll_compair_price_split = coll_original_compair_up
          .toString()
          .split(".");

        var coll_up_price =
          `<small><s><span class="visually-hidden">` +
          coll_compair_up +
          `</span>
          <small aria-hidden="true" class="coll_prd_compare_price">` +
          coll_compair_price_split[0] +
          `<sup>` +
          coll_compair_price_split[1] +
          `</sup></small>
          <span class="visually-hidden">` +
          coll_compair_up +
          `</span></s></small>`;
        price_compair_element += coll_up_price;
      }
      $(this).find(".product-item--price .h1").html(price_compair_element);
    });
    add_margin(value, text);

    $(".gsttag").css("display", "none");
  });

  $(".wholesale_margin").on("click", function () {
    
    var text = $(this).val();
    $(".marginset").text(text);

    $(".new-margin .grid-item").each(function () {
      var whole_sale_price = $(this).find(".product-item--price").attr("data-wholesale-price");
      var whole_compare_price = $(this).find(".product-item--price").attr("data-compare-price");
      
      var wholesale_arr = whole_sale_price.split(".");     
      var lastVal = wholesale_arr.pop();       
      var firstVal = wholesale_arr.join(".");

      var price_text = firstVal+`<sup>`+lastVal+`</sup>`;
      
      $(this).find(".product-item--price .h1 small.main_price").html(price_text);
      
      if(whole_compare_price != "$0.00")
      {
          var compare_wholesale_arr = whole_compare_price.split(".");     
          var compare_lastVal = compare_wholesale_arr.pop();       
          var compare_firstVal = compare_wholesale_arr.join(".");
    
          var compare_price_text = compare_firstVal+`<sup>`+compare_lastVal+`</sup>`;
          $(this).find(".product-item--price .h1 small.coll_prd_compare_price").html(compare_price_text);
      }
    });

    
    add_margin(1, text);

    $(".gsttag").css("display", "block");
  });

  $(document).on("change", ".single-option-selector", function () {
    setTimeout(function () {
      console.log($("#productSelect-product-template").val());
      margin();
    }, 5);
  });

  function margin() {
    var marginset = localStorage.getItem("margin");
    setTimeout(function(){
    $('[name="margin_quantity"]').val(marginset);
    
    var marginstatus = localStorage.getItem("marginstatus");
    if (marginstatus == "Retail") {
      $(".apply_margin").trigger("click");
    }

    else// (marginstatus == "Wholesale") {
    { $(".wholesale_margin").trigger("click");
    }
        }, 50)
  }

  // intialize margin
  
    margin();  
  
  

  $("div.myclass").hover(function () {
    $(this).css("background-color", "red");
  });
});
